import { mobiClient } from '@/services/axiosConfig'
import { CheckNumberRes, GetBillRes } from './types'
import { encodeToBase64 } from '@/utils/helpers'

export const getBillInfo = async (isdn: string, register: string, type: string): Promise<GetBillRes | undefined> => {
  try {
    const headers = {
      isdn,
      type,
      register: encodeToBase64(register)
    }
    const res = await mobiClient.get('/bill', { headers })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const checkNumber = async (isdn: string, type: string): Promise<CheckNumberRes | undefined> => {
  try {
    const res = await mobiClient.get('/bill/check', { headers: { isdn, type } })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
